import documentsReducer, { defaultState, type DokumentState, type Dokument, type SaveScrollPosition } from "./documentsReducer";

export { defaultState, type DokumentState, type Dokument, type SaveScrollPosition };
export default documentsReducer;
